import { render } from "./FullScreenModal.vue?vue&type=template&id=ddb5875a&scoped=true"
import script from "./FullScreenModal.vue?vue&type=script&lang=js"
export * from "./FullScreenModal.vue?vue&type=script&lang=js"

import "./FullScreenModal.vue?vue&type=style&index=0&id=ddb5875a&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddb5875a"]])

export default __exports__